import React, { useEffect, useState } from "react";
import "../Styles/userProfile.css";
import TopNav from "../layouts/TopNav";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../util/axios";

interface Permission {
  view: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
}

interface RolePermissions {
  [key: string]: Permission;
}

const UserProfile: React.FC = () => {
  const [permissions, setPermissions] = useState<RolePermissions | null>(null);
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    // Fetch user permissions on component mount
    api
      .get("/roles", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        const userRole = res.data.data[0].permissions; 
        setPermissions(userRole);
      })
      .catch((err) => {
        console.error(err);
        Swal.fire({
          title: "Error!",
          text: "Failed to fetch user permissions.",
          icon: "error",
          confirmButtonColor: "red",
        });
      });
  }, [token]);


  return (
    <div className="board">
      <TopNav title="User Account Profile" />

      <div className="userPro">
        <h2 className="pb-4">Select User</h2>
        <div className="userBtn">
         
            <Link to="/dashboard/adminstaff">
              <button>Admin</button>
            </Link>
            {/* <button>Admin</button> */}
        
            <Link to="/dashboard/superstaff">
              <button>Senior Staff</button>
            </Link>
            {/* <button >Senior Staff</button> */}
            <Link to="/dashboard/stafftable">
              <button>Staff</button>
            </Link>
            {/* <button>Staff</button> */}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
